<template>
  <div id="uploadWrapper">
    <input type="file" :ref="csvRefName" hidden="true" @change="handleCsvUpload" />

    <template v-if="showButton">
      <v-btn @click="initiateFileUploadDialog">{{ buttonText }}</v-btn>
    </template>

    <template v-if="showCard">
      <v-card flat>
        <v-card-title class="justify-center">
          <div>
            <v-img
              height="256x"
              width="256px"
              src="/images/csvupload256.png"
              @click.native.stop="initiateFileUploadDialog"
            />
            <p class="header text-md-center">Upload your CSV</p>
            <p class="header text-md-center">Use comma or tab delimited files</p>
          </div>
        </v-card-title>
      </v-card>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'csv-upload',
  props: {
    buttonText: {
      type: String,
      required: false,
      default: 'Upload CSV'
    },
    type: {
      type: String,
      require: true,
      validator: function (value) {
        // must be one of these values
        return ['card', 'button'].indexOf(value) !== -1
      }
    }
  },
  data: function () {
    return {}
  },

  computed: {
    ...mapState('CsvMappingStore', ['csvFile', 'csvFileMeta']),
    showButton () {
      return this.type === 'button'
    },
    showCard () {
      return this.type === 'card'
    },
    csvRefName () {
      return 'csvUpload' + this.type
    }

  },
  methods: {
    initiateFileUploadDialog () {
      this.$refs[this.csvRefName].click()
    },
    handleCsvUpload () {
      const file = this.$refs[this.csvRefName].files[0]
      if (file) {
        this.$store.dispatch('CsvMappingStore/updateMapping', {
          name: file.name.split('.').slice(0, -1)[0],
          csvFile: file,
          csvFileMeta: {
            original_name: file.name,
            lastModified: file.lastModified,
            lastModifiedDate: file.lastModifiedDate,
            size: file.size,
            type: file.type
          }
        })
        this.$emit('on-file-selected', file)
      }
    }
  }
}
</script>
